import React, { useEffect, useState } from 'react';
import { AmplifyAuthProvider } from 'src/auth/auth';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AppProvider from '@amzn/aes-maestro-website-core/dist/components/providers/AppProvider';
import AmplifyFetch from 'src/utils/amplify-fetch';
import Spinner from '@amzn/aes-maestro-website-core/dist/components/base/Spinner/Spinner';
import { routes } from 'src/routing';

function App() {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);

  useEffect(() => {
    /**
     * Authenticate user.
     */
    async function authenticateUser() {
      const user = await AmplifyAuthProvider.authenticateUser();
      // set user authenticated.
      setIsUserAuthenticated(!!user);
    }

    authenticateUser();
  }, []);

  if (!isUserAuthenticated) return null;

  return (
    <AppProvider fetcher={AmplifyFetch}>
      <React.Suspense fallback={<Spinner />}>
        <RouterProvider router={createBrowserRouter(routes)} />
      </React.Suspense>
    </AppProvider>
  );
}

export default App;
